import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

const REDACTED = '_REDACTED_'

export const useMapRedactedToLabel = () => {
  const { t } = useTranslation()

  const mapRedactedToLabel = useCallback(
    (value?: string | null) => {
      if (value?.includes(REDACTED)) {
        return t('typography.redacted')
      }

      return value ?? ''
    },
    [t]
  )

  return { mapRedactedToLabel }
}
